import Vue from 'vue'
import Router from 'vue-router'

import LaunchPage from '@/components/launch-page'
import SettingsPage from '@/components/settings-page'
import CustomerPage from '@/components/customer-page'
import UtilityPage from '@/components/utility-page'

Vue.use(Router)

export default new Router({
  routes: [
    { path: '/', component: LaunchPage },
    { path: '/settings', component: SettingsPage },
    { path: '/customer', component: CustomerPage },
    { path: '/utility', component: UtilityPage }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js